// src/App/Components/TypingLoader.tsx
import React from 'react';

const TypingLoader: React.FC<{ size?: number; color?: string }> = ({
  size = 10,
  color = '#888',
}) => {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: color,
        animation: 'pulse 1.2s ease-in-out infinite',
        margin: '4px 0',
      }}
    >
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              transform: scale(0.6);
              opacity: 0.4;
            }
            50% {
              transform: scale(1.2);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

export default TypingLoader;
